import createStyleSyncService from './services/styleSyncService';

export default (editor, config = {}) => {
    const tm = editor.TraitManager;
    const styleSyncService = createStyleSyncService(editor);

    tm.addType('slider-with-input', {
        createInput({ trait }) {
            const component = trait.target;
            const property = trait.get('property') || 'height';
            const min = trait.get('min') ?? 0;
            const max = trait.get('max') ?? 500;
            const step = trait.get('step') ?? 1;
            const unit = trait.get('unit') || 'px';
            const labelText = trait.get('displayLabel') || 'Height';
            const defaultValue = trait.get('default') ?? 0;
            const currentRaw = styleSyncService.readPropertyValue({ component, property, unit });
            const parsedCurrent = Number.parseFloat(currentRaw);
            const current = Number.isFinite(parsedCurrent) ? parsedCurrent : defaultValue;

            const wrapper = document.createElement('div');
            wrapper.style.cssText = 'display:flex;flex-direction:column;gap:0px;width:100%;margin-top:4px;margin-bottom:4px;';

            const title = document.createElement('div');
            title.textContent = labelText;
            title.style.cssText = 'font-size:14px;line-height:1.3; margin: 2px 0px;';

            const controlsRow = document.createElement('div');
            controlsRow.style.cssText = 'display:flex;align-items:center;gap:8px;width:100%;';

            const slider = document.createElement('input');
            slider.type = 'range';
            slider.min = min;
            slider.max = max;
            slider.step = step;
            slider.value = current;
            slider.style.cssText = 'flex:1;min-width:0;accent-color:#0991b2;cursor:pointer;margin:0;appearance: auto; color: light-dark(rgb(16, 16, 16), rgb(255, 255, 255)); padding: initial; border: initial; margin: 2px;';

            const numberInput = document.createElement('input');
            numberInput.type = 'number';
            numberInput.min = min;
            numberInput.max = max;
            numberInput.step = step;
            numberInput.value = current;
            numberInput.style.cssText = 'width:58px;border:1px solid #444;border-radius:4px;color:#fff;font-size:14px;padding:3px 5px;text-align:right;outline:none;text-align:center;';

            const unitLabel = document.createElement('span');
            unitLabel.textContent = unit;
            unitLabel.style.cssText = 'color:#888;font-size:14px;min-width:14px;';

            const syncFromStyles = () => {
                const raw = styleSyncService.readPropertyValue({ component, property, unit });
                const parsedValue = Number.parseFloat(raw);
                const fallbackValue = Number.isFinite(parsedValue) ? parsedValue : defaultValue;
                const clamped = Math.max(min, Math.min(max, fallbackValue));
                slider.value = clamped;
                numberInput.value = clamped;
            };

            const applyValue = (val) => {
                const parsedValue = Number.parseFloat(val);
                if (!Number.isFinite(parsedValue)) return;
                const clamped = Math.max(min, Math.min(max, parsedValue));
                slider.value = clamped;
                numberInput.value = clamped;
                styleSyncService.applyStyleValue({
                    component,
                    property,
                    value: `${clamped}${unit}`,
                });
            };

            wrapper._unsubscribeDeviceChange = styleSyncService.subscribeToDeviceChangesForElement({
                element: wrapper,
                onChange: syncFromStyles,
            });

            slider.addEventListener('input', () => applyValue(slider.value));
            numberInput.addEventListener('change', () => applyValue(numberInput.value));
            numberInput.addEventListener('input', () => applyValue(numberInput.value));

            controlsRow.append(slider, numberInput, unitLabel);
            wrapper.append(title, controlsRow);
            wrapper._slider = slider;
            wrapper._numberInput = numberInput;
            wrapper._property = property;
            wrapper._unit = unit;
            wrapper._syncFromStyles = syncFromStyles;

            return wrapper;
        },

        onUpdate({ elInput, component, trait }) {
            if (!elInput._slider) return;
            if (typeof elInput._syncFromStyles === 'function') {
                elInput._syncFromStyles();
                return;
            }
            const property = elInput._property || trait.get('property') || 'height';
            const unit = elInput._unit || trait.get('unit') || 'px';
            const defaultValue = trait.get('default') ?? 0;
            const raw = styleSyncService.readPropertyValue({ component, property, unit });
            const parsedValue = Number.parseFloat(raw);
            const val = Number.isFinite(parsedValue) ? parsedValue : defaultValue;
            elInput._slider.value = val;
            elInput._numberInput.value = val;
        },

        onEvent() {},
    });

};
